import { useEffect } from "react";
import Routes from "./routes";
import ReactPixel from "react-facebook-pixel";

// Initialize Meta Pixel with correct ID
// autoConfig: false - we don't auto-fire PageView since GTM may also be tracking
// const META_PIXEL_ID = '556522438278059';
// ReactPixel.init(META_PIXEL_ID, {}, { autoConfig: false, debug: false });

function App() {
  useEffect(() => {
    let cart = localStorage.getItem("products");

    if (!cart) localStorage.setItem("products", "[]");
  }, []);

  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
